export function hasAuditoriaSinter(tenantConfig?: { [key: string]: unknown } | null): boolean {
  return tenantConfig?.auditoriaSinter === true;
}
